import script from "./CreateShop.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateShop.vue?vue&type=script&lang=ts&setup=true"

import "./CreateShop.vue?vue&type=style&index=0&id=8a23418a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a23418a"]])

export default __exports__